import { Hidden, useTheme } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import React, { type FC } from 'react';

import { updateImageUrl } from '../../../../utils';
import {
  MOBILE_APP_ICON_WIDTH,
  MOBILE_APP_ICON_HEIGHT,
  MOBILE_APP_ICON_GIF_OR_SVG,
  MOBILE_APP_ICON,
} from './constants';
import { type MobileAppIconProps } from './types';

export const MobileAppIcon: FC<MobileAppIconProps> = ({ title, titleImage }) => {
  const { getTestId } = useTestId();
  const theme = useTheme();

  if (!titleImage) {
    return null;
  }
  const isGifOrSvg =
    titleImage.toLowerCase().includes('inputformat=gif') || titleImage.toLowerCase().includes('inputformat=svg');

  if (isGifOrSvg) {
    return (
      <img
        data-testid={getTestId(MOBILE_APP_ICON_GIF_OR_SVG)}
        alt={title}
        loading="lazy"
        src={titleImage}
        width={MOBILE_APP_ICON_WIDTH}
        height={MOBILE_APP_ICON_HEIGHT}
      />
    );
  }

  const imageData = {
    url: titleImage,
    passPNG: false,
    jpgSettings: ['h=120', 'q=90', `ib=${encodeURIComponent(theme.palette.grey[100])}`],
  };

  return (
    <>
      <Hidden mdUp>
        <img
          data-testid={getTestId(MOBILE_APP_ICON)}
          alt={title}
          loading="lazy"
          src={updateImageUrl(imageData)}
          width={MOBILE_APP_ICON_WIDTH}
          height={MOBILE_APP_ICON_HEIGHT}
        />
      </Hidden>
      <Hidden mdDown>
        <img
          data-testid={getTestId(MOBILE_APP_ICON)}
          alt={title}
          loading="lazy"
          src={updateImageUrl(imageData)}
          width={MOBILE_APP_ICON_WIDTH}
          height={MOBILE_APP_ICON_HEIGHT}
        />
      </Hidden>
    </>
  );
};
